<template>
  <div class="dashboard">
    <div class="row" v-if="user !== null && user.userprofile.user_type.slug === 'obea_admin'">
        <HomeItem :title="$t('documention')" :description="$t('access_documentation')" :img="require('@/assets/home-documents.svg')" link="/documentation/"/>
        <HomeItem :title="$t('raw_result')" :description="$t('find_ressources')" :img="require('@/assets/home-results.svg')" link="/rawresults/"/>
        <HomeItem :title="$t('report_deposit')" :description="$t('publish_report')" :img="require('@/assets/home-deposit.svg')" link="/reviewdeposit/"/>
        <HomeItem title="Administration" description="Gérez le contenu de la plateforme" :img="require('@/assets/home-administration.svg')" link="/dashboard/administration/userlist/"/>
        <HomeItem title="Reporting" :img="require('@/assets/home-surveyoption.svg')" link="/dashboard/administration/reporting/survey/"/>
        <HomeItem blank=true />
      </div>
      <div class="row" v-else>
        <HomeItem v-if="user.userprofile.user_type.services.includes('documentation')" :title="$t('documention')" :description="$t('access_documentation')" :img="require('@/assets/home-documents.svg')" link="/documentation/"/>
        <HomeItem  v-if="user.userprofile.user_type.services.includes('user')" :title="$t('users_list')" :description="$t('manage_users')" :img="require('@/assets/home-employee.svg')" link="/users/list/"/>
        <HomeItem  v-if="user.userprofile.user_type.services.includes('companies')" :title="$t('companies')" :description="$t('manage_companies')" :img="require('@/assets/home-company.svg')" link="/company/"/>
        <HomeItem  v-if="user.userprofile.user_type.services.includes('survey')" :title="$t('surveys_list')" :description="$t('manage_survey')" :img="require('@/assets/home-survey.svg')" link="/survey/"/>
        <HomeItem  v-if="user.userprofile.user_type.services.includes('report') || user.userprofile.user_type.services.includes('softconcept')" title="Résultats Enquête" description="Accès aux résultats" :img="require('@/assets/home-report.svg')" link="/get-report/"/>
        <HomeItem  v-if="user.userprofile.user_type.services.includes('reporting')" title="Reporting" :img="require('@/assets/home-surveyoption.svg')" link="/dashboard/administration/reporting/survey/"/>
        <HomeItem  v-if="user.userprofile.user_type.services.includes('roadmap')" title="Plan d'actions" :img="require('@/assets/home-surveyoption.svg')" link="/plan-actions/"/>
        <HomeItem  title="Espace de Partage" description="Contenus et bonnes pratiques QVT"  :img="require('@/assets/sharespace.png')" link="/share/inspiration/"/>
          <HomeItem title="B-e Box" description="La boîte à outils Bien-être" :img="require('@/assets/be-box.png')" link="/bebox/"/>
      </div>
    </div>
</template>

<script>
  import HomeItem from '../components/HomeItem'
  import { mapState } from 'vuex';
  export default {
    name: 'dashboard',
    components: { HomeItem },
    computed: mapState({ user: state => state.user.user }),
    data() {
    },
    layout(context) {
      return 'layout'
    },
    methods: {
    },
  };
</script>
